export const urlToPathname = (url: string): string => {
  try {
    const urlObj = new URL(url);

    return urlObj.pathname;
  } catch {
    return url;
  }
};
